import { render } from "./SliderTypeFarm.vue?vue&type=template&id=e6e7c950"
import script from "./SliderTypeFarm.vue?vue&type=script&lang=js"
export * from "./SliderTypeFarm.vue?vue&type=script&lang=js"

import "./SliderTypeFarm.vue?vue&type=style&index=0&id=e6e7c950&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__